import { useNavigate } from "react-router-dom";
import usePublicGraphQLQuery from "../../lib/usePublicGraphqlQuery";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { toastOptions } from "../../../data/toastOptions";

const useForgotPasswordMutations = () => { 
  // Custom Hook to use GraphQL Public Queries
  const publicGraphQLQuery = usePublicGraphQLQuery();
  // For redirect to home after reset pwd 
  const navigate = useNavigate();
  
  // Forogt Password Mutation Query
  const forgotPasswordMutation = useMutation({
    mutationKey: ["forgotPassword"],
    mutationFn: (forgotPasswordParam: string) => publicGraphQLQuery(forgotPasswordParam).then(response => response?.data),
    onSettled: (response) => {
      if (response?.data?.forgotPassword) {
        toast.success("A code has been sent to your email.", toastOptions);
      } else if (response?.errors) {
        response?.errors.forEach((err: any) => {
          toast.error(err.message, toastOptions);
        });
      }
    },
  });
  
  // Pwd Code Recovery Mutation Query
  const codeRecoveryMutation = useMutation({
    mutationKey: ["recoverCode"],
    mutationFn: (codeRecoveryParam: string) => publicGraphQLQuery(codeRecoveryParam).then(response => response?.data),
    onSettled: (response) => {
      if (response?.data?.recoverPassword) {
        const recoverCodeStatus = response?.data?.recoverPassword?.status;
        const recoverCodeMessage = response?.data?.recoverPassword?.message;
        if (recoverCodeStatus === 200) {
         toast.success("Valid Code. Please reset your password", toastOptions);
        }
        else if (recoverCodeStatus === 404) {
          toast.error("Invalid Code. Please insert the valid code", toastOptions); 
        }
        else {
          recoverCodeMessage ? toast.error(recoverCodeMessage, toastOptions):
          toast.error("Server error. Please try again later.", toastOptions);
        }
      } else if (response?.errors) {
        response?.errors.forEach((err: any) => {
          toast.error(err.message, toastOptions);
        });
      }
    },
  });
  
  // Recover Password Mutation Query
  const recoverPasswordMutation = useMutation({
    mutationKey: ["recoverPassword"],
    mutationFn: (pwdRecoveryParam: string) => publicGraphQLQuery(pwdRecoveryParam).then(response => response?.data),
    onSettled: (response) => {
      if (response?.data?.recoverPassword) {
        const recoverCodeStatus = response?.data?.recoverPassword?.status;
        const recoverCodeMessage = response?.data?.recoverPassword?.message;
        if (recoverCodeStatus === 200) {
          toast.success("Your password has been updated successfully.", toastOptions);
          navigate('/');
        }
        else if (recoverCodeStatus === 404) {
          toast.error("Code no longer valid. Please try again.", toastOptions); 
        }
        else {
          recoverCodeMessage ? toast.error(recoverCodeMessage, toastOptions):
          toast.error("Server error. Please try again later.", toastOptions);
        }
      } else if (response?.errors) {
        response?.errors.forEach((err: any) => {
          toast.error(err.message, toastOptions);
        });
      }
    },
  });
    
  const isAnyMutationPending = (): boolean => {
    return forgotPasswordMutation.isPending || codeRecoveryMutation.isPending || recoverPasswordMutation.isPending;
  }
    
    return { forgotPasswordMutation, codeRecoveryMutation, recoverPasswordMutation, isAnyMutationPending };
};
export default useForgotPasswordMutations;